import { gql } from "@apollo/client";

export const VehicleData = gql`
  query searchVehicleAccountByVehicleNo($keyword: String) {
    searchVehicleAccountByVehicleNo(keyword: $keyword) {
      _id
      RC_Number
      Vehicle_Type
      Load_Capacity
      Search_Value
    }
  }
`;

export const gtPartData = gql`
  query SearchPart_Masters($keyword: String, $consignor: ID) {
    searchPart_Masters(keyword: $keyword, consignor: $consignor) {
      _id
      Part_Name
      Part_Number
      Dimension
      Customer_Account {
        _id
      }
      Quantity_Per_Box
      Packaging {
        _id
        Type_Of_Packaging
        Search_Value
      }
      Inc_CMS
      Weight
      Content
      Search_Value
      createdAt
      updatedAt
    }
  }
`;

export const gtPickupData = gql`
  query SearchPickUpMemo($keyword: String) {
    SearchPickUpMemo(keyword: $keyword) {
      _id
      PRS_NO
      Vendor
      Vehicle
      Driver_Name
      Search_Value
      Driver_Number
      LoadReceiptsData {
        _id
        Date
        LR_No
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
      RemainingCNData {
        _id
        Date
        LR_No
        Total_Weight
        Total_Volumetric_Weight
        Total_Actual_Weight
        Total_Number_Of_Boxes
      }
    }
  }
`;

const Loadfilds = [
  {
    id: Math.random() * 10,
    name: "Consignment_Note_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Date",
        label: "Date",
        type: "Date",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Service_Type",
        label: "Service Type",
        type: "InputDropForQuery",
        masterName: "ServiceTypeData",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Freight_Type",
        type: "inputdrop",
        dropdowncontent: ["Paid", "To Pay", "TBB", "FOC"],
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Delivery",
        type: "inputdrop",
        dropdowncontent: ["Door", "Godown", "Office"],
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "From_City",
        label: "From City",
        setvalue: "City",
        disable: true,
        FirstCharCap: true,
        isRequired: true,
        type: "InputDropForQuery",
        masterName: "City_Master",
      },
      {
        id: Math.random() * 10,
        name: "To_City",
        label: "To City",
        setvalue: "City",
        disable: true,
        FirstCharCap: true,
        isRequired: true,
        type: "InputDropForQuery",
        masterName: "City_Master",
      },
      {
        id: Math.random() * 10,
        name: "LR_Center",
        label: "LR Center",
        type: "InputDropForQuery",
        masterName: "LR_Center_Data",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        // disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Assign_Pickup",
        label: "Assign Pickup",
        type: "InputDropForQuery",
        masterName: "Branch",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "LR_No",
        label: "CN No",
        disableDependOn: {
          section: "Consignment_Note_Details",
          name: "LR_Center",
          disableOn: "Editable",
          disableOnValue: "No",
          value: null,
          // clearValue:false
        },
        type: "number",
        min: 1,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Auto_LR_Number",
      //   label: "Auto CN No",
      //   type: "checkbox",
      //   min: 2,
      //   max: Infinity,
      // },
    ],
  },
];

const UserDetails = [
  {
    id: Math.random() * 10,
    name: "Consignor_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Consignor",
        label: "Consignor ",
        type: "InputDropForQuery",
        masterName: "ERPAddressBook",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Consignor_GST_No",
        label: "GST No",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Consignor_City",
        label: "City",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Consignor_Address",
        label: "Address",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Consignor_Person",
        label: "Contact Person",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        autoComplete: "off",
        Reference_field: ["Consignor", "Refered_To"],
        masterName: "AccountContactPerson",

        isSearchable: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Consignor_Person",
      //   type: "inputdrop",
      //   masterName: "Vendor_Account",
      //   min: 2,
      //   max: Infinity,
      // },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Consignee_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Consignee",
        label: "Consignee ",
        type: "InputDropForQuery",
        masterName: "ERPAddressBook",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Consignee_GST_No",
        label: "GST No",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Consignee_City",
        label: "City",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Consignee_Address",
        label: "Address",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Consignee_Person",
        label: "Contact Person",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        autoComplete: "off",
        Reference_field: ["Consignee", "Refered_To"],
        masterName: "AccountContactPerson",
        require: true,
        isSearchable: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Consignee_Person",
      //   type: "inputdrop",
      //   masterName: "Vendor_Account",
      //   min: 2,
      //   max: Infinity,
      // },
    ],
  },
  {
    id: Math.random() * 10,
    name: "Bill_Account_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Bill_Consignor",
        label: "Bill Consignor ",
        type: "InputDropForQuery",
        masterName: "Customer_Account_For_CN",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Bill_GST_No",
        label: "GST No",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_City",
        label: "City",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Consignor_Address",
        label: "Address",
        type: "text",
        min: 2,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Bill_Consignor_Person",
        label: "Contact Person",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        autoComplete: "off",
        Reference_field: ["Bill_Consignor", "Refered_To"],
        masterName: "AccountContactPerson",
        require: true,
        isSearchable: true,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Bill_Consignor_Person",
      //   type: "inputdrop",
      //   masterName: "Vendor_Account",
      //   min: 2,
      //   max: Infinity,
      // },
    ],
  },
];

const DocUpload = [
  {
    id: Math.random() * 10,
    name: "Approval",
    label: "Approval",
    isRequired: true,
  },
  {
    id: Math.random() * 10,
    name: "Request",
    label: "Request",
  },
  {
    id: Math.random() * 10,
    name: "Invoice_1",
    label: "Invoice 1",
  },
  {
    id: Math.random() * 10,
    name: "Invoice_2",
    label: "Invoice 2",
  },
  {
    id: Math.random() * 10,
    name: "Eway_Bill_1",
    label: "Eway Bill 1",
  },
  {
    id: Math.random() * 10,
    name: "Eway_Bill_2",
    label: "Eway Bill 2",
  },
  {
    id: Math.random() * 10,
    name: "POD",
    label: "POD",
  },
  {
    id: Math.random() * 10,
    name: "Other_Documents",
    label: "Other Document",
  },
];

const AddMaterial = [
  {
    id: Math.random() * 10,
    name: "Add_Meterial",
    fields: [
      {
        id: Math.random() * 10,
        name: "Invoice_Date",
        label: "Invoice Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "Invoice_Number",
        label: "Invoice Number",
        type: "text",
        min: 1,
        AllCaps: true,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Invoice_Value",
        label: "Invoice Value",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Eway_Bill_Date",
        label: "Eway Bill Date",
        type: "Date",
      },
      {
        id: Math.random() * 10,
        name: "Eway_Bill_Number",
        label: "Eway Bill Number",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Eway_Bill_Expiry_Date",
        label: "Eway Bill Expiry Date",
        type: "Date",
        restrictDateRange: true,
        Reference_field: "Eway_Bill_Date",
      },
      {
        id: Math.random() * 10,
        name: "ASN_No",
        label: "ASN Number",
        type: "number",
        min: 1,
        max: Infinity,
      },
    ],
  },
];

const AddMeterialDocsUpload = [
  {
    id: Math.random() * 10,
    name: "Invoice_Add",
    label: "Invoice",
  },
  {
    id: Math.random() * 10,
    name: "Eway_Bill_Add",
    label: "Eway Bill",
  },
];

const AddMeterialItems = [
  {
    id: Math.random() * 10,
    name: "Add_Items",
    fields: [
      {
        id: Math.random() * 10,
        name: "No_Of_Boxes",
        label: "No Of Article",
        type: "number",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Part_Name",
        label: "Part Name ",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        masterName: "gtPartData",
      },
      {
        id: Math.random() * 10,
        name: "Part_Number",
        label: "Part Number",
        type: "text",
        AllCaps: true,
      },
      {
        id: Math.random() * 10,
        name: "Content",
        label: "Content",
        type: "text",
        AllCaps: true,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Packaging",
        label: "Packaging ",
        type: "InputDropForQuery",
        clearField: "Branch_Code",
        masterName: "searchPackaging",
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Weight",
        label: "Actual Weight (Per Article)",
        type: "number",
      },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "Quantity_Per_Box",
            label: "Quantity Per Box",
            type: "number",
            min: 1,
            max: Infinity,
          },
          {
            id: Math.random() * 10,
            name: "Total_Quantity",
            label: "Total Quantity",
            type: "number",
            min: 1,
            max: Infinity,
          },
        ],
      },

      // {
      //   id: Math.random() * 10,
      //   name: "Length",
      //   label: "Length",
      //   type: "number",
      //   min: 2,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Breadth",
      //   label: "Breadth",
      //   type: "number",
      //   min: 2,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Height",
      //   label: "Height",
      //   type: "number",
      //   min: 2,
      //   max: Infinity,
      // },
      // <label className="text-dimetion-area">{label}</label>
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "Box_Dimension",
            label: "Dimension(L×W×H)",
            type: "inputMask",
            mask: "99 x *9 x *9",
            inputBoxNumber: 3,
            inputDigitLimit: 3,
            // type:"DimensionsMask",
          },
          {
            id: Math.random() * 10,
            name: "Inc_CMS",
            label: "Inc/CMS",
            type: "inputdrop",
            dropdowncontent: ["in", "cm"],
            min: 2,
            max: Infinity,
          },
        ],
      },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "CFT",
            label: "CFT",
            type: "number",
            min: 2,
            max: Infinity,
            disabled: true,
          },
          {
            id: Math.random() * 10,
            name: "CFT_Ratio",
            label: "CFT Ratio",
            type: "number",
            min: 2,
            max: Infinity,
          },
        ],
      },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "Volumetric_Weight",
            label: "Volumetric Wt (kg)",
            type: "number",
            min: 2,
            max: Infinity,
            disabled: true,
          },
          {
            id: Math.random() * 10,
            name: "Actual_Weight",
            label: "Actual Weight (kg)",
            type: "number",
            min: 2,
            max: Infinity,
          },
        ],
      },
      {
        id: Math.random() * 10,
        name: "Charge_Weight",
        label: "Charge Weight (Kgs)",
        type: "number",
        min: 2,
        max: Infinity,
        // disabled: true,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Sidebyside",
        Subfields: [
          {
            id: Math.random() * 10,
            name: "Rate",
            label: "Rate",
            type: "number",
            min: 1,
            max: Infinity,
          },
          {
            id: Math.random() * 10,
            name: "Freight_On",
            label: "Freight On",
            type: "inputdrop",
            dropdowncontent: ["Weight", "Per Article", "Quantity", "Fixed"],
            min: 1,
            max: Infinity,
          },
        ],
      },
      {
        id: Math.random() * 10,
        name: "Freight_Amount",
        label: "Freight Amount",
        type: "number",
        min: 1,
        max: Infinity,
        // disabled: true,
        isRequired: true,
      },
    ],
  },
];

const FreightCharges = [
  {
    id: Math.random() * 10,
    name: "Freight_Charges",
    fields: [
      // {
      //   id: Math.random() * 10,
      //   name: "Total_Weight",
      //   label: "Total Weight",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      //   disabled: true,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Rate",
      //   label: "Rate",
      //   type: "number",
      //   min: 1,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "Freight_On",
      //   label: "Freight On",
      //   type: "inputdrop",
      //   dropdowncontent: ["Weight", "Per Article", "Per KM", "Quantity", "Fixed"],
      //   min: 1,
      //   max: Infinity,
      // },
      {
        id: Math.random() * 10,
        name: "Freight_Amount",
        label: "Freight Amount",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "Docket_Amount",
        label: "Docket Amount",
        value: 0,
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Pickup_Charges",
        label: "Pickup Charges",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Delivery_Charges",
        label: "Delivery Charges",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "FOV",
        label: "FOV",
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
      {
        id: Math.random() * 10,
        name: "FSC",
        label: "FSC",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Holding_Charge",
        label: "Holding Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Hamali_Charge",
        label: "Hamali Charge",
        type: "number",
        min: 1,
        max: Infinity,
      },
      {
        id: Math.random() * 10,
        name: "Other_Charges",
        label: "Other Charges",
        type: "number",
        min: 1,
        max: Infinity,
      },
      // {
      //   id: Math.random() * 10,
      //   name: "GSTPaidBy",
      //   label: "GST Paid By",
      //   type: "inputdrop",
      //   dropdowncontent: ["Consignor", "Consignee", "Bil Consignor", "Transporter"],
      //   min: 2,
      //   max: Infinity,
      // },
      // {
      //   id: Math.random() * 10,
      //   name: "TaxType",
      //   label: "Tax Type",
      //   type: "inputdrop",
      //   dropdowncontent: ["GST", "IGST"],
      //   min: 2,
      //   max: Infinity,
      // },
      {
        id: Math.random() * 10,
        name: "Total",
        label: "Sub Total",
        formula: [
          { name: "Freight_Amount", opt: "+" },
          { name: "Docket_Amount", opt: "+" },
          { name: "Pickup_Charges", opt: "+" },
          { name: "Delivery_Charges", opt: "+" },
          { name: "FOV", opt: "+" },
          { name: "FSC", opt: "+" },
          { name: "Hamali_Charge", opt: "+" },
          { name: "Holding_Charge", opt: "+" },
          { name: "Other_Charges", opt: "+" },
        ],
        type: "number",
        min: 1,
        max: Infinity,
        disabled: true,
      },
    ],
  },
];

const ConsignmentNoteConfiguration = [
  {
    id: Math.random() * 10,
    name: "Config_Details",
    fields: [
      {
        id: Math.random() * 10,
        name: "Default_Service_Type",
        label: "Default Service Type",
        type: "InputDropForQuery",
        masterName: "ServiceTypeData",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Default_Freight_Type",
        type: "inputdrop",
        dropdowncontent: ["Paid", "To Pay", "TBB", "FOC"],
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Default_Delivery",
        type: "inputdrop",
        dropdowncontent: ["Door", "Godown", "Office"],
        min: 2,
        max: Infinity,
        isRequired: true,
      },
      {
        id: Math.random() * 10,
        name: "Default_From_City",
        label: "Default From City",
        setvalue: "City",
        disable: true,
        FirstCharCap: true,
        isRequired: true,
        type: "InputDropForQuery",
        masterName: "City_Master",
      },
      {
        id: Math.random() * 10,
        name: "Default_To_City",
        label: "Default To City",
        setvalue: "City",
        disable: true,
        FirstCharCap: true,
        isRequired: true,
        type: "InputDropForQuery",
        masterName: "City_Master",
      },
      // {
      //   id: Math.random() * 10,
      //   name: "Default_LR_Center",
      //   label: "Default LR Center",
      //   type: "InputDropForQuery",
      //   masterName: "LR_Center_Data",
      //   clearField: "Branch_Code",
      //   min: 2,
      //   max: Infinity,
      //   // disabled: true,
      // },
      {
        id: Math.random() * 10,
        name: "Default_Assign_Pickup",
        label: "Default Assign Pickup",
        type: "InputDropForQuery",
        masterName: "Branch",
        clearField: "Branch_Code",
        min: 2,
        max: Infinity,
      },
    ],
  },
];

export {
  Loadfilds,
  DocUpload,
  AddMaterial,
  AddMeterialDocsUpload,
  AddMeterialItems,
  UserDetails,
  FreightCharges,
  ConsignmentNoteConfiguration,
};
